import { FormatTime } from 'common/formatters';
import moment from 'moment';
import AppointmentBadge, { getAppointmentDisplayStatus } from '../AppointmentBadge';
import { getStatusBarColor } from 'common/StatusBadge';


export default function WeekView({ startDate, appointments, handlePopupToggle }) {
    const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    const colCount = 7;
    let dateCountIndex = 0;

    const getDate = (startDate, index) => {
        return new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + index);
    };

    const increaseDateCountIndex = () => {
        dateCountIndex++;
    };

    const createDateString = (date) => {
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate().toString().padStart(2, '0');
    };

    const getDateAppointments = (date) => {
        const formattedDate = moment(date).format('DD-MM-YYYY');
        return appointments?.filter(
            (appointment) => moment(appointment?.appointment_date).format('DD-MM-YYYY') === formattedDate,
        );
    };

    return (
        <>
            <div className="grid grid-cols-7 gap-2" style={{ borderRadius: '12px 12px 0px 0px' }}>
                {days.map((day) => (
                    <div
                        key={day}
                        className="text-center rounded-t-md text-xs uppercase poppins-semibold"
                        style={{ 
                            color: '#4b5563', 
                            backgroundColor: '#E1E1E1',
                            padding: '12px 16px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '12px 12px 0px 0px',
                            fontWeight: 700,
                            borderBottom: '#9CA3AF 1px solid'
                        }}
                    >
                        {day}
                    </div>
                ))}
            </div>

            <div className="grid grid-cols-7 h-full gap-2" style={{ borderRadius: '12px 12px 0px 0px' }}>
                {[...Array(colCount)].map((_, index) => (
                    <div
                        key={index}
                        className="bg-white min-h-[120px] p-2 rounded-md text-black text-sm relative"
                        style={{ borderTopLeftRadius: '0px', borderTopRightRadius: '0px' }}
                    >
                        <div className="flex justify-end items-center mb-2">
                            <span
                                className={`text-lg ${createDateString(getDate(startDate, dateCountIndex)) ===
                                    createDateString(new Date())
                                    ? 'font-bold'
                                    : ''
                                    }`}
                                style={{
                                    color:
                                        createDateString(getDate(startDate, dateCountIndex)) ===
                                            createDateString(new Date())
                                            ? '#ff5f39'
                                            : 'black',
                                }}
                            >
                                {getDate(startDate, index).getDate()}
                            </span>
                        </div>

                        {getDateAppointments(createDateString(getDate(startDate, dateCountIndex))).map((appointment) => (
                            <div
                                key={appointment?.id}
                                className={`cursor-pointer mt-2 hover:bg-structure pl-1 pr-3 py-1 rounded-lg hover:text-primary flex items-center poppins-regular`}
                                onClick={(e) => {
                                    handlePopupToggle(e, appointment);
                                }}
                            >
                                {/* Status Bar - match MonthView */}
                                <div
                                    className="w-[4px] h-12 min-h-[48px] rounded-full flex-shrink-0"
                                    style={{
                                        backgroundColor: getStatusBarColor(
                                            getAppointmentDisplayStatus(
                                                appointment?.status,
                                                appointment?.appointment_date,
                                                appointment?.time
                                            )
                                        ),
                                    }}
                                ></div>

                                <div className="ml-2 flex-1 flex flex-col justify-center overflow-hidden text-ellipsis">
                                    {/* Provider/Name - 12px */}
                                    <div className="text-[12px] font-normal poppins ">
                                        {appointment?.provider_name}
                                    </div>

                                    {/* Time + Service - 10px */}
                                    <div className="flex items-center gap-2 text-[10px] text-structure4 overflow-hidden text-ellipsis whitespace-nowrap">
                                        <span className="overflow-hidden text-ellipsis">
                                            {FormatTime(appointment?.time)}, {appointment?.service_data?.[0]?.serviceName || appointment?.service_data?.[0]?.name || appointment?.service_data?.[0]?.description || 'Service'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {increaseDateCountIndex()}
                    </div>
                ))}
            </div>
        </>
    );
}